import { jsx } from 'react/jsx-runtime';
import { createElement } from 'react';
import cn from 'classnames';
import { Button } from '../Button/Button.js';
import { Popup } from '../Popup/Popup.js';
import S from './PopupMenu.styl.js';

function PopupMenu({ items, onClose, ...props }) {
    if (items.length === 0)
        return null;
    const { size } = props;
    return (jsx(Popup, { ...props, content: jsx("div", { className: S.list, children: items.map(({ id, title, className, ...rest }) => (createElement(Button, { variant: "clear", size: size, ...rest, className: cn(S.item, className), key: id }, title))) }) }));
}

export { PopupMenu };
